import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { LabelTextImpl } from "./label-text.styles.es.js";
import "react";
import "@reach/auto-id";
import "lodash/fp";
import "styled-components";
import { useDisplayMode } from "../../hooks/use-display-mode.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import "compute-scroll-into-view";
const propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  displayMode: PropTypes.oneOf(["light", "dark"]),
  htmlFor: PropTypes.string,
  id: PropTypes.string
};
const defaultProps = {
  as: void 0,
  displayMode: void 0,
  htmlFor: void 0,
  id: void 0
};
const LabelText = ({
  as,
  children,
  displayMode: displayModeProp,
  htmlFor,
  id
}) => {
  const displayMode = useDisplayMode(displayModeProp);
  return /* @__PURE__ */ jsx(LabelTextImpl, { as, htmlFor, id, $displayMode: displayMode, children });
};
LabelText.propTypes = propTypes;
LabelText.defaultProps = defaultProps;
export {
  LabelText
};
